module.exports = __webpack_public_path__ + "img/son.134a3192.svg";